import { Controller } from "@hotwired/stimulus"

// Simple expand/collapse controller for progressive disclosure
export default class extends Controller {
  static targets = ["content", "icon", "trigger"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.render()
    this.element.setAttribute("data-ready", "")
  }

  toggle() {
    this.openValue = !this.openValue
    this.render()
  }

  open() {
    this.openValue = true
    this.render()
  }

  close() {
    this.openValue = false
    this.render()
  }

  render() {
    if (this.hasContentTarget) {
      if (this.openValue) {
        // Use a very large max-height to allow natural growth (like generated strategy view)
        // This allows the content to grow naturally as children (like textarea) expand
        this.contentTarget.style.maxHeight = "9999px"
        this.contentTarget.style.opacity = "1"
      } else {
        this.contentTarget.style.maxHeight = "0"
        this.contentTarget.style.opacity = "0"
      }
    }

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.openValue ? "rotate(180deg)" : "rotate(0deg)"
    }

    this.triggerTargets.forEach(trigger => {
      trigger.setAttribute("aria-expanded", this.openValue.toString())
    })
  }
}
